import React from "react";
import styled from "styled-components";
import { path } from "ramda";
import I18n from "../../i18n/index";
import { TooltipText } from "../text/OText";
import { Colors, Icons, Metrics } from "../../theme/index";
import InfoErrorStatus from "../../constants/errorStatus";

const { InfoIcon, ErrorIcon } = Icons;
const BoxContainer = styled.div`
	border: 1px solid ${props=>Colors.borderColor};
	border-radius: 8px;
	padding: 24px;
	display:flex;
`;
const InfoBox = styled.div`
	margin-left: ${props=>Metrics.button.bigSpaceMargin}px;
`;
const IconStyle = {
	display:"flex", 
	fontSize: 25, 
	lineHight:1.5,
	alignSelf:"center"
};
export const ReportErrorHandler = ({value, children, forceError})=>{
	let status = path(["error","status"], value);
	if(forceError){
		status = Math.random() >= 0.5 ?
			InfoErrorStatus.NOT_ENOUGH_DATA:
			InfoErrorStatus.SERVER_ERROR;
	}
	if(status){
		let message = path(["error","message"], value);
		switch(status){
		case InfoErrorStatus.NOT_ENOUGH_DATA:
			return <LimitDataBox message={message}/>;
		case InfoErrorStatus.SERVER_ERROR:
			return <SomethingWentWrongBox message={message}/>;
		default:
			return <SomethingWentWrongBox message={message}/>;
		}
	}else{
		return children;
	}
};

export const SomethingWentWrongBox = (props)=>(
	<BoxContainer {...props}>
		<ErrorIcon style={IconStyle}/>
		<InfoBox>
			<div>{I18n.t("server_error.title")}</div>
			{/* {props.message ? <div>{props.message}</div> : <React.Fragment />} */}
		</InfoBox>
	</BoxContainer>
);

export const LimitDataBox = (props)=>(
	<BoxContainer {...props}>
		<InfoIcon style={IconStyle} />
		<InfoBox>
			<div>{I18n.t("not_enough_data_title")}</div>
			{props.message ? <div>{props.message}</div> : <React.Fragment />}
		</InfoBox>
	</BoxContainer>
);


// WEBPACK FOOTER //
// ./src/components/report/ErrorGraphBox.js